import React, { useState, useEffect } from "react";
import { SimpleDropdown } from "../../../components/common/SimpleDropdown";

const registrationStatusOptions = [
  { value: "", label: "Select Status" },
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
];

export const EditScrapeJobModal = ({ job, isOpen, onClose, onUpdate, loading }) => {
  const [formData, setFormData] = useState({
    registrationStatus: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    jerseyNumber: "",
    position: "",
    height: "",
    weight: "",
    batsThrows: "",
    hometown: "",
    highSchool: "",
    previousSchool: "",
    // Batting stats
    battingSeasonYear: "",
    battingGamesPlayed: "",
    battingAtBats: "",
    battingRuns: "",
    battingHits: "",
    battingDoubles: "",
    battingTriples: "",
    battingHomeRuns: "",
    battingRbi: "",
    battingAverage: "",
    battingOnBasePercentage: "",
    battingSluggingPercentage: "",
    battingWalks: "",
    battingStrikeouts: "",
    battingStolenBases: "",
    // Pitching stats
    pitchingSeasonYear: "",
    pitchingWins: "",
    pitchingLosses: "",
    pitchingEra: "",
    pitchingGamesPitched: "",
    pitchingInningsPitched: "",
    pitchingStrikeoutsPitched: "",
    // Fielding stats
    fieldingSeasonYear: "",
    fieldingPutouts: "",
    fieldingAssists: "",
    fieldingErrors: "",
    fieldingPercentage: "",
    fieldingDoublePlays: "",
  });

  useEffect(() => {
    if (job) {
      const battingStats = job.battingStats?.[0] || {};
      const pitchingStats = job.pitchingStats?.[0] || {};
      const fieldingStats = job.fieldingStats?.[0] || {};

      setFormData({
        registrationStatus: job.registrationStatus || "",
        firstName: job.firstName || "",
        lastName: job.lastName || "",
        email: job.email || "",
        phoneNumber: job.phoneNumber || "",
        jerseyNumber: job.jerseyNumber || "",
        position: job.position || "",
        height: job.height || "",
        weight: job.weight || "",
        batsThrows: job.batsThrows || "",
        hometown: job.hometown || "",
        highSchool: job.highSchool || "",
        previousSchool: job.previousSchool || "",
        // Batting stats
        battingSeasonYear: battingStats.seasonYear || "",
        battingGamesPlayed: battingStats.games_played || "",
        battingAtBats: battingStats.at_bats || "",
        battingRuns: battingStats.runs || "",
        battingHits: battingStats.hits || "",
        battingDoubles: battingStats.doubles || "",
        battingTriples: battingStats.triples || "",
        battingHomeRuns: battingStats.home_runs || "",
        battingRbi: battingStats.rbi || "",
        battingAverage: battingStats.batting_average || "",
        battingOnBasePercentage: battingStats.on_base_percentage || "",
        battingSluggingPercentage: battingStats.slugging_percentage || "",
        battingWalks: battingStats.walks || "",
        battingStrikeouts: battingStats.strikeouts || "",
        battingStolenBases: battingStats.stolen_bases || "",
        // Pitching stats
        pitchingSeasonYear: pitchingStats.seasonYear || "",
        pitchingWins: pitchingStats.wins || "",
        pitchingLosses: pitchingStats.losses || "",
        pitchingEra: pitchingStats.era || "",
        pitchingGamesPitched: pitchingStats.games_pitched || "",
        pitchingInningsPitched: pitchingStats.innings_pitched || "",
        pitchingStrikeoutsPitched: pitchingStats.strikeouts_pitched || "",
        // Fielding stats
        fieldingSeasonYear: fieldingStats.seasonYear || "",
        fieldingPutouts: fieldingStats.putouts || "",
        fieldingAssists: fieldingStats.assists || "",
        fieldingErrors: fieldingStats.errors || "",
        fieldingPercentage: fieldingStats.fielding_percentage || "",
        fieldingDoublePlays: fieldingStats.double_plays || "",
      });
    }
  }, [job]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    // Transform form data back to API format
    const updateData = {
      registrationStatus: formData.registrationStatus,
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      jerseyNumber: formData.jerseyNumber,
      position: formData.position,
      height: formData.height,
      weight: formData.weight,
      batsThrows: formData.batsThrows,
      hometown: formData.hometown,
      highSchool: formData.highSchool,
      previousSchool: formData.previousSchool,
      battingStats: [{
        seasonYear: formData.battingSeasonYear,
        games_played: Number(formData.battingGamesPlayed) || 0,
        at_bats: Number(formData.battingAtBats) || 0,
        runs: Number(formData.battingRuns) || 0,
        hits: Number(formData.battingHits) || 0,
        doubles: Number(formData.battingDoubles) || 0,
        triples: Number(formData.battingTriples) || 0,
        home_runs: Number(formData.battingHomeRuns) || 0,
        rbi: Number(formData.battingRbi) || 0,
        batting_average: Number(formData.battingAverage) || 0,
        on_base_percentage: Number(formData.battingOnBasePercentage) || 0,
        slugging_percentage: Number(formData.battingSluggingPercentage) || 0,
        walks: Number(formData.battingWalks) || 0,
        strikeouts: Number(formData.battingStrikeouts) || 0,
        stolen_bases: Number(formData.battingStolenBases) || 0,
      }],
      pitchingStats: [{
        seasonYear: formData.pitchingSeasonYear,
        wins: Number(formData.pitchingWins) || 0,
        losses: Number(formData.pitchingLosses) || 0,
        era: Number(formData.pitchingEra) || 0,
        games_pitched: Number(formData.pitchingGamesPitched) || 0,
        innings_pitched: Number(formData.pitchingInningsPitched) || 0,
        strikeouts_pitched: Number(formData.pitchingStrikeoutsPitched) || 0,
      }],
      fieldingStats: [{
        seasonYear: formData.fieldingSeasonYear,
        putouts: Number(formData.fieldingPutouts) || 0,
        assists: Number(formData.fieldingAssists) || 0,
        errors: Number(formData.fieldingErrors) || 0,
        fielding_percentage: Number(formData.fieldingPercentage) || 0,
        double_plays: Number(formData.fieldingDoublePlays) || 0,
      }],
    };

    onUpdate(updateData);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-6xl max-h-[90vh] rounded-3xl bg-jp-card border border-jp-line shadow-2xl overflow-hidden">
        <div className="overflow-y-auto max-h-[90vh] px-6 py-6 md:px-10 md:py-8">
          <h2 className="text-center text-sm md:text-lg font-semibold text-jp-ink mb-5">
            EDIT SCRAPE JOB - {job?.playerName}
          </h2>

          {/* Basic Information */}
          <div className="rounded-2xl bg-jp-section border border-jp-line p-6 mb-6">
            <h3 className="text-jp-ink font-semibold mb-4 text-sm">Basic Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-xs text-jp-muted mb-2">Registration Status</label>
                <SimpleDropdown
                  value={formData.registrationStatus}
                  onChange={(val) => setFormData({ ...formData, registrationStatus: val })}
                  options={registrationStatusOptions}
                  placeholder="Select Status"
                  variant="admin"
                  buttonClassName="w-full px-3 pr-8 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs cursor-pointer flex items-center justify-between"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Phone Number</label>
                <input
                  type="text"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Jersey Number</label>
                <input
                  type="text"
                  name="jerseyNumber"
                  value={formData.jerseyNumber}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Position</label>
                <input
                  type="text"
                  name="position"
                  value={formData.position}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Height</label>
                <input
                  type="text"
                  name="height"
                  value={formData.height}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Weight</label>
                <input
                  type="text"
                  name="weight"
                  value={formData.weight}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Bats/Throws</label>
                <input
                  type="text"
                  name="batsThrows"
                  value={formData.batsThrows}
                  onChange={handleChange}
                  placeholder="e.g., L/L or R/R"
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Hometown</label>
                <input
                  type="text"
                  name="hometown"
                  value={formData.hometown}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">High School</label>
                <input
                  type="text"
                  name="highSchool"
                  value={formData.highSchool}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Previous School</label>
                <input
                  type="text"
                  name="previousSchool"
                  value={formData.previousSchool}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
            </div>
          </div>

          {/* Batting Stats */}
          <div className="rounded-2xl bg-jp-section border border-jp-line p-6 mb-6">
            <h3 className="text-jp-ink font-semibold mb-4 text-sm">Batting Statistics</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="col-span-2 md:col-span-1">
                <label className="block text-xs text-jp-muted mb-2">Season Year</label>
                <input
                  type="text"
                  name="battingSeasonYear"
                  value={formData.battingSeasonYear}
                  onChange={handleChange}
                  placeholder="e.g., 2024-25"
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Games Played</label>
                <input
                  type="number"
                  name="battingGamesPlayed"
                  value={formData.battingGamesPlayed}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">At Bats</label>
                <input
                  type="number"
                  name="battingAtBats"
                  value={formData.battingAtBats}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Runs</label>
                <input
                  type="number"
                  name="battingRuns"
                  value={formData.battingRuns}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Hits</label>
                <input
                  type="number"
                  name="battingHits"
                  value={formData.battingHits}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Doubles</label>
                <input
                  type="number"
                  name="battingDoubles"
                  value={formData.battingDoubles}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Triples</label>
                <input
                  type="number"
                  name="battingTriples"
                  value={formData.battingTriples}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Home Runs</label>
                <input
                  type="number"
                  name="battingHomeRuns"
                  value={formData.battingHomeRuns}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">RBI</label>
                <input
                  type="number"
                  name="battingRbi"
                  value={formData.battingRbi}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Batting Avg</label>
                <input
                  type="number"
                  step="0.001"
                  name="battingAverage"
                  value={formData.battingAverage}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">On-Base %</label>
                <input
                  type="number"
                  step="0.001"
                  name="battingOnBasePercentage"
                  value={formData.battingOnBasePercentage}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Slugging %</label>
                <input
                  type="number"
                  step="0.001"
                  name="battingSluggingPercentage"
                  value={formData.battingSluggingPercentage}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Walks</label>
                <input
                  type="number"
                  name="battingWalks"
                  value={formData.battingWalks}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Strikeouts</label>
                <input
                  type="number"
                  name="battingStrikeouts"
                  value={formData.battingStrikeouts}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Stolen Bases</label>
                <input
                  type="number"
                  name="battingStolenBases"
                  value={formData.battingStolenBases}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
            </div>
          </div>

          {/* Pitching Stats */}
          <div className="rounded-2xl bg-jp-section border border-jp-line p-6 mb-6">
            <h3 className="text-jp-ink font-semibold mb-4 text-sm">Pitching Statistics</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="col-span-2 md:col-span-1">
                <label className="block text-xs text-jp-muted mb-2">Season Year</label>
                <input
                  type="text"
                  name="pitchingSeasonYear"
                  value={formData.pitchingSeasonYear}
                  onChange={handleChange}
                  placeholder="e.g., 2024-25"
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Wins</label>
                <input
                  type="number"
                  name="pitchingWins"
                  value={formData.pitchingWins}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Losses</label>
                <input
                  type="number"
                  name="pitchingLosses"
                  value={formData.pitchingLosses}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">ERA</label>
                <input
                  type="number"
                  step="0.01"
                  name="pitchingEra"
                  value={formData.pitchingEra}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Games Pitched</label>
                <input
                  type="number"
                  name="pitchingGamesPitched"
                  value={formData.pitchingGamesPitched}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Innings Pitched</label>
                <input
                  type="number"
                  step="0.1"
                  name="pitchingInningsPitched"
                  value={formData.pitchingInningsPitched}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Strikeouts</label>
                <input
                  type="number"
                  name="pitchingStrikeoutsPitched"
                  value={formData.pitchingStrikeoutsPitched}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
            </div>
          </div>

          {/* Fielding Stats */}
          <div className="rounded-2xl bg-jp-section border border-jp-line p-6 mb-6">
            <h3 className="text-jp-ink font-semibold mb-4 text-sm">Fielding Statistics</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="col-span-2 md:col-span-1">
                <label className="block text-xs text-jp-muted mb-2">Season Year</label>
                <input
                  type="text"
                  name="fieldingSeasonYear"
                  value={formData.fieldingSeasonYear}
                  onChange={handleChange}
                  placeholder="e.g., 2024-25"
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Putouts</label>
                <input
                  type="number"
                  name="fieldingPutouts"
                  value={formData.fieldingPutouts}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Assists</label>
                <input
                  type="number"
                  name="fieldingAssists"
                  value={formData.fieldingAssists}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Errors</label>
                <input
                  type="number"
                  name="fieldingErrors"
                  value={formData.fieldingErrors}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Fielding %</label>
                <input
                  type="number"
                  step="0.001"
                  name="fieldingPercentage"
                  value={formData.fieldingPercentage}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
              <div>
                <label className="block text-xs text-jp-muted mb-2">Double Plays</label>
                <input
                  type="number"
                  name="fieldingDoublePlays"
                  value={formData.fieldingDoublePlays}
                  onChange={handleChange}
                  className="w-full px-3 py-2 bg-jp-section border border-jp-line rounded-lg text-jp-ink text-xs focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-center gap-4">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="min-w-[140px] h-10 rounded-full border border-sky-300 bg-transparent text-[12px] font-semibold text-sky-100 hover:bg-sky-900/40 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              CANCEL
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="min-w-[160px] h-10 rounded-full bg-sky-500 text-[12px] font-semibold text-jp-ink hover:bg-sky-400 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "SAVING..." : "SAVE CHANGES"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
